export function getJWPlayer() {
  return typeof window !== "undefined" ? window.jwplayer?.() : undefined;
}

export function pauseJWPlayer() {
  const player = getJWPlayer();

  if (player && player.pause) {
    player.pause();
  }
}
